import PropTypes from "prop-types";
import {
  CloseSquareOutlined,
  UpOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";

const ProductTypeItem = (props) => {
  const {
    item,
    selectedItem,
    itemId,
    itemIndex,
    totalItems,
    columnsPerRow,
    handleDeleteTypeProduct,
    handleSelectedItem,
    onMoveItem,
  } = props;
  const isSelectedItem = selectedItem._id === itemId;

  const handleMove = (e, direction) => {
    e.stopPropagation();
    if (onMoveItem) {
      onMoveItem(itemIndex, direction);
    }
  };

  // Calculate if arrows should be disabled
  const currentRow = Math.floor(itemIndex / columnsPerRow);
  const totalRows = Math.ceil(totalItems / columnsPerRow);
  const isFirstRow = currentRow === 0;
  const isLastRow = currentRow === totalRows - 1;
  const isFirstInRow = itemIndex % columnsPerRow === 0;
  const isLastInRow =
    itemIndex % columnsPerRow === columnsPerRow - 1 ||
    itemIndex === totalItems - 1;

  return (
    <div
      className={`product-type-item-wrapper ${
        isSelectedItem ? "item-selected" : ""
      }`}
    >
      {isSelectedItem && (
        <>
          <CloseSquareOutlined
            className="icon-close"
            onClick={() => handleDeleteTypeProduct(item)}
          />
          {onMoveItem && (
            <div className="arrow-controls">
              <UpOutlined
                className={`arrow-btn arrow-up ${isFirstRow ? "disabled" : ""}`}
                onClick={(e) => !isFirstRow && handleMove(e, "up")}
              />
              <DownOutlined
                className={`arrow-btn arrow-down ${isLastRow ? "disabled" : ""}`}
                onClick={(e) => !isLastRow && handleMove(e, "down")}
              />
              <LeftOutlined
                className={`arrow-btn arrow-left ${isFirstInRow ? "disabled" : ""}`}
                onClick={(e) => !isFirstInRow && handleMove(e, "left")}
              />
              <RightOutlined
                className={`arrow-btn arrow-right ${isLastInRow ? "disabled" : ""}`}
                onClick={(e) => !isLastInRow && handleMove(e, "right")}
              />
            </div>
          )}
        </>
      )}
      <div
        className="handle-item-wrapper"
        onClick={() => handleSelectedItem(item)}
        title={item.name}
      >
        <div className="type-image">
          <img src={item.image} />{" "}
        </div>
        <div className="type-name ellipsis-text-one-line">{item.name} </div>
      </div>
    </div>
  );
};

ProductTypeItem.propTypes = {
  item: PropTypes.object,
  selectedItem: PropTypes.object,
  itemId: PropTypes.string,
  itemIndex: PropTypes.number,
  totalItems: PropTypes.number,
  columnsPerRow: PropTypes.number,
  handleDeleteTypeProduct: PropTypes.func,
  handleSelectedItem: PropTypes.func,
  onMoveItem: PropTypes.func,
};

export default ProductTypeItem;
